import React from 'react';
import { Typography, useTheme, Box } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

/**
 * @param {Object} data - format --> { "Done": 80, "Pending": 20 }
 * @param {String} title - Text to show in the center
 * @param {Number} size - Diameter of the chart
 * @param {Array} colors - Custom color array
 */
function ProfileCompletionPieChart({ data = {}, title = "", cutout = '60%', size = 118, colors }) {
  const theme = useTheme();

  // Default colors: Success Green for first slice, Light Grey for second
  const defaultColors = colors || [
    theme.palette.success.main, 
    theme.palette.grey[200]
  ];

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
    // This creates the hollow center for the title
    cutout: cutout, 
  };

  const total = Object.values(data).reduce((acc, val) => acc + val, 0);

  const chartData = {
    labels: Object.keys(data),
    datasets: [
      {
        data: Object.values(data),
        backgroundColor: defaultColors,
        borderWidth: 0,
        hoverOffset: 2,
      },
    ],
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        position: 'relative',
      }}
    >
      {total > 0 ? (
        <>
          <Doughnut data={chartData} options={options} />
          {title && (
            <Typography
              sx={{
                position: 'absolute',
                color: 'text.secondary',
                fontSize: size < 60 ? 8 : 10,
                fontWeight: 'bold',
                pointerEvents: 'none', // Allows hover effects on chart
                textAlign: 'center',
                width: '100%',
              }}
            >
              {title}
            </Typography>
          )}
        </>
      ) : (
        <Box
          sx={{
            backgroundColor: theme.palette.grey[100],
            width: '100%',
            height: '100%',
            borderRadius: '50%',
          }}
        />
      )}
    </Box>
  );
}

export default ProfileCompletionPieChart;